import { StageDef } from '../automationMachineInterfaces'
import { goToInstagramSettingPageStageDefs } from './goToSettingPageStageDefs'
import { generateToggleStageDefs } from './instagramToggleUtils'
import { hiddenWordsUrl } from './instagramUrls'
import { InstagramSettingKey } from '../../recommendations/recommendationSettingsKeys'
import { InstagramRecommendationKey } from '../../utils/enums'
import {
  defaultCantUndoFn,
  defaultIsDisabledFn,
  defaultIsDisabledReasonFn,
  getCurrentValueFnFromKey,
  getIsFulfilledFnFromKey,
} from '../recommendationCardDisplayUtils'

const saveKey = InstagramSettingKey.HIDE_COMMENTS
const sectionTitle = 'Hide comments'
const targetValue = true

const getCurrentValueFn = (key) =>
  getCurrentValueFnFromKey(key, (value) => (value ? 'On' : 'Off'))
const getIsFulfilledFn = (key) => getIsFulfilledFnFromKey(key, (value) => value)
const getCantUndoFn = () => defaultCantUndoFn
const getIsDisabledFn = () => defaultIsDisabledFn
const getIsDisabledReasonFn = () => defaultIsDisabledReasonFn

enum StageKey {
  GATHER_HIDE_COMMENTS = 'GATHER_HIDE_COMMENTS',
  UPDATE_HIDE_COMMENTS = 'UPDATE_HIDE_COMMENTS',
  UNDO_HIDE_COMMENTS = 'UNDO_HIDE_COMMENTS',
}

const {
  gatherStageDefs: gatherToggleStageDefs,
  updateStageDefs: updateToggleStageDefs,
  undoStageDefs: undoToggleStageDefs,
} = generateToggleStageDefs(
  InstagramRecommendationKey.INSTAGRAM_HIDE_COMMENTS,
  [sectionTitle],
  () => saveKey,
  () => targetValue,
  StageKey.GATHER_HIDE_COMMENTS,
  StageKey.UPDATE_HIDE_COMMENTS,
  StageKey.UNDO_HIDE_COMMENTS,
  null, // Null URL. Page navigation is done via the menu
)

const gatherStageDefs: StageDef[] = [
  ...goToInstagramSettingPageStageDefs(
    StageKey.GATHER_HIDE_COMMENTS,
    'Hidden Words',
    hiddenWordsUrl,
  ),
  ...gatherToggleStageDefs,
]
const updateStageDefs: StageDef[] = [
  ...goToInstagramSettingPageStageDefs(
    StageKey.UPDATE_HIDE_COMMENTS,
    'Hidden Words',
    hiddenWordsUrl,
  ),
  ...updateToggleStageDefs,
]
const undoStageDefs: StageDef[] = [
  ...goToInstagramSettingPageStageDefs(
    StageKey.UNDO_HIDE_COMMENTS,
    'Hidden Words',
    hiddenWordsUrl,
  ),
  ...undoToggleStageDefs,
]

export {
  getCantUndoFn,
  getCurrentValueFn,
  getIsDisabledFn,
  getIsDisabledReasonFn,
  getIsFulfilledFn,
  gatherStageDefs,
  updateStageDefs,
  undoStageDefs,
}
